import { ThemeProvider } from '@cbhq/cds-web/system/ThemeProvider';
import { useLogger, MicrocopyProvider, CMSProvider, Div } from '@cbhq/cdx-components';
import { fallbackFonts } from '../globals/fallbackFonts.js';
import { getSiteConfigMicrocopies } from '../globals/siteSettings.js';
import { jsx } from 'react/jsx-runtime';
const ThemeProviderWithChildren = ThemeProvider;

/**
 * Sets up component maps and themes for a given template.
 * This ComponentProvider depends on cdx-component's ComponentProvider being instantiated.
 */
function PageTemplateProviders({
  componentMap = {},
  children,
  siteConfig,
  locale = 'en',
  cdsPalette,
  cdsThemeMode
}) {
  const _useLogger = useLogger(),
    logError = _useLogger.logError;
  const microcopies = getSiteConfigMicrocopies(siteConfig);
  return /*#__PURE__*/jsx(MicrocopyProvider, {
    microcopies: microcopies,
    children: /*#__PURE__*/jsx(CMSProvider, {
      locale: locale,
      onError: logError,
      components: componentMap,
      children: /*#__PURE__*/jsx(ThemeProviderWithChildren, {
        spectrum: cdsThemeMode,
        palette: cdsPalette,
        children: /*#__PURE__*/jsx(Div, {
          css: {
            fontFamily: `'CoinbaseSans', ${fallbackFonts}`
          },
          children: children
        })
      })
    })
  });
}
export { PageTemplateProviders };
//# sourceMappingURL=PageTemplateProviders.js.map
